import { render, staticRenderFns } from "./ProviderPerformance.vue?vue&type=template&id=2add5da0&scoped=true"
import script from "./ProviderPerformance.vue?vue&type=script&lang=js"
export * from "./ProviderPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProviderPerformance.vue?vue&type=style&index=0&id=2add5da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add5da0",
  null
  
)

export default component.exports